/* eslint-disable no-undef */

import {store} from 'react-easy-state';
import {Record} from 'immutable';
import CodiceFiscale from 'codice-fiscale-js';
import Bluebird from 'bluebird';

// ============================================================================

import {
  genTextValidation,
  emailValidation,
  telValidation,
  cfValidation,
  capValidation,
  impSValidation,
  impYValidation,
  impYValidationEl,
} from '../utils/validators';

const NUCLEAR_FORM_ID = window.location.href.includes ('/en/') ? 39556 : 39556;
const GEMELLI_FORM_ID = window.location.href.includes ('/en/') ? 24760 : 1953;
const COLUMBUS_FORM_ID = window.location.href.includes ('/en/') ? 24756 : 4506;

const prestazione = Record ({
  id: 0,
  name: undefined,
  disponibilita: 'Entrambi',
  struttura: false,
  preparazione: false,
  impData: Date.now (),
  impTipo: null,
  impS: null,
  impY: null,
  impN: null,
  peso: null,
  altezza: null,
  impMotivo: null,
  isComplete: false,
  popup: false,
});

const anagraficaFactory = Record ({
  nome: '',
  cognome: '',
  cf: '',
  nascitaData: '',
  nascitaComune: '',
  sesso: '',
  cellulare: '',
  email: '',
  confemail: '',
  resIndirizzo: '',
  resCap: '',
  resStato: '',
  resComune: '',
  consentGdpr: 'Y',
  consentDati: 'Y',
  consentNews1: 'N',
  consentNews2: 'N',
});

const Store = store ({
  _isSending: false,
  _prestazioni4elenco: KFPG_PRESTAZIONI,
  _anagrafica: false,
  isSent: false,
  isModalOpen: false,
  modalContent: '',
  isElencoPrestOpen: false,
  get anagrafica () {
    return Store._anagrafica || anagraficaFactory ();
  },
  closeModal () {
    Store.isModalOpen = false;
  },
  setModalOpen (content) {
    Store.isModalOpen = true;
    Store.modalContent = content;
  },
  setModalClose () {
    Store.isModalOpen = false;
  },
  reset () {
    Store.prestazioni = [prestazione ()];
    Store._anagrafica = false;
    Store.isSent = false;
    Store._isSending = false;
  },
  prestazioni: [prestazione ()],
  setPrestazione({
    idx,
    id,
    name,
    disponibilita,
    preparazione,
    popup,
    richiesta,
  }) {
    const struttura = disponibilita !== 'Entrambi' ? disponibilita : null;
    Store.prestazioni[idx] = prestazione ({
      id,
      name,
      disponibilita,
      struttura,
      preparazione,
      popup,
    });

    if (popup && richiesta) {
      Store.setModalOpen (richiesta);
    }
  },
  setPrestazioneFromWater (rawWater) {
    const distilled = atob (rawWater);
    const startPrest = JSON.parse (distilled);

    if (!startPrest.id) {
      return false;
    }

    console.log ('startPrest', startPrest);

    Store.setPrestazione ({
      idx: 0,
      id: startPrest.id,
      name: startPrest.nome,
      disponibilita: startPrest.dove || 'Entrambi',
      preparazione: startPrest.link_prep || false,
      popup: (startPrest.popup && startPrest.popup !== '0') || null,
      richiesta: startPrest.richiesta && startPrest.richiesta !== ''
        ? atob (startPrest.richiesta)
        : false,
    });
  },
  updatePrestazione (idx, key, value) {
    console.log (idx, key, value);
    const prestUpdated = Store.prestazioni[idx].set (key, value);
    Store.prestazioni[idx] = prestUpdated;
  },
  updateDatiPersonali (key, value) {
    const datiUpdated = Store._anagrafica.set (key, value);
    Store._anagrafica = datiUpdated;
  },
  setStruttura (idx, struttura) {
    Store.updatePrestazione (idx, 'struttura', struttura);
  },
  resetPrestazione (idx) {
    Store.prestazioni[idx] = prestazione ();
  },
  deletePrestazione (idx) {
    const prestArrayCopy = Store.prestazioni.slice ();
    prestArrayCopy.splice (idx, 1);
    Store.prestazioni = prestArrayCopy;
  },
  addPrestazione () {
    Store.prestazioni.push (prestazione ());
  },
  startAnagrafica () {
    Store._anagrafica = anagraficaFactory ();
  },
  showModBtn (idx) {
    const prest = Store.prestazioni[idx];

    return !Store.isSent && prest.get ('name');
  },
  showDelBtn (idx) {
    return !Store.isSent && Store.prestazioni.length > 1;
  },
  showSceltaStruttura (idx) {
    const prest = Store.prestazioni[idx];

    return (
      prest.get ('name') &&
      prest.get ('disponibilita') === 'Entrambi' &&
      !prest.get ('struttura')
    );
  },
  showInstaSearch (idx) {
    const prest = Store.prestazioni[idx];

    return !prest.get ('name') || !prest.get ('struttura');
  },
  showStruttura (idx) {
    const prest = Store.prestazioni[idx];

    return prest.get ('struttura') !== false;
  },
  showPrestImpegnativa (idx) {
    const prest = Store.prestazioni[idx];

    return prest.get ('name') && prest.get ('struttura') && !Store.isSent;
  },
  showInputDatiImpegnativa (idx) {
    const prest = Store.prestazioni[idx];

    return Store.showPrestImpegnativa (idx) && prest.get ('impTipo');
  },
  showPrestContinuaBtn (idx) {
    const prest = Store.prestazioni[idx];

    if (!Store.showInputDatiImpegnativa (idx) || !prest.get ('impTipo')) {
      return false;
    }
    if (prest.get ('impTipo') === 'IC') {
      return (
        impSValidation (prest.get ('impS')) &&
        impYValidation (prest.get ('impY'))
      );
    }

    if (prest.get ('impTipo') === 'RE') {
      return impYValidationEl (prest.get ('impY'));
    }

    return false;
  },
  showDownloadPdfBtn (idx) {
    const prest = Store.prestazioni[idx];

    return Store.isSent && prest.preparazione;
  },
  canShowCompleteStuffs (idx) {
    const prest = Store.prestazioni[idx];
    const isThisComplete = prest.get ('isComplete');
    const isThis = idx === Store.prestazioni.length - 1;
    const otherIncomplete = (function () {
      if (Store.prestazioni.length === 1) {
        return false;
      }

      let hasIncomplete = false;
      Store.prestazioni.forEach (prest => {
        if (!prest.get ('isComplete')) {
          hasIncomplete = true;
        }
      });

      return hasIncomplete;
    }) ();

    return isThis && isThisComplete && !otherIncomplete && !Store._anagrafica;
  },
  disdettaEmail () {
    const retval = [];

    Store.prestazioni.forEach (prest => {
      if (
        prest.get ('struttura').includes ('Gemelli') &&
        !retval.includes ('G')
      )
        retval.push ('G');
      if (
        prest.get ('struttura').includes ('Columbus') &&
        !retval.includes ('C')
      )
        retval.push ('C');
    });

    console.log ('disdettaEmail--->', retval);
    return retval;
  },
  isPersonalDataValid () {
    const anag = Store.anagrafica;

    const validFields = [
      genTextValidation (anag.nome),
      genTextValidation (anag.cognome),
      cfValidation (anag.cf),
      telValidation (anag.cellulare),
      emailValidation (anag.email),
      emailValidation (anag.confemail),
      anag.email === anag.confemail,
      genTextValidation (anag.resIndirizzo),
      capValidation (anag.resCap),
      genTextValidation (anag.resComune),
      genTextValidation (anag.resStato),
      anag.consentGdpr === 'Y',
      anag.consentDati === 'Y',
    ];

    let _isValid = true;
    validFields.forEach (f => {
      if (f === false) {
        _isValid = false;
      }
    });

    return _isValid;
  },
  canSendRequest () {
    const prests = Store.prestazioni;

    return (
      Store.isPersonalDataValid () &&
      prests.filter (prest => !prest.get ('isComplete')).length === 0
    );
  },
  async submit () {
    if (!Store.canSendRequest () || Store._isSending) {
      return false;
    }

    Store._isSending = true;

    const {prestazioni, anagrafica} = Store;
    const cf = new CodiceFiscale (anagrafica.cf.toUpperCase ()).toJSON ();

    const makeNote = prest => {
      const _peso = prest.get ('peso')
        ? '\nPeso: ' + prest.get ('peso') + ' kg'
        : '';
      const _alte = prest.get ('altezza')
        ? '\nAltezza: ' + prest.get ('altezza') + ' cm'
        : '';
      const _note = prest.get ('impMotivo') || '';

      return '\n' + _note + '\n' + _peso + _alte;
    };

    const popupValueAsBoolean = popupRawValue => {
      if (typeof popupRawValue === 'undefined') return false;
      if (popupRawValue === null) return false;
      if (popupRawValue === false) return false;
      if (Array.isArray (popupRawValue) && popupRawValue.length === 0)
        return false;

      console.log ('isnuke', popupRawValue);
      return true;
    };

    await Bluebird.resolve (prestazioni).map (
      async (prest, i) => {
        const formData = new FormData ();
        const dataImp = new Date (prest.get ('impData'))
          .toISOString ()
          .split ('T')[0];
        const impS = prest.get ('impTipo') === 'IC' ? prest.get ('impS') : '';
        const impY = prest.get ('impTipo') === 'IC' ? prest.get ('impY') : '';
        const impRe = prest.get ('impTipo') === 'RE' ? prest.get ('impY') : '';
        const note = makeNote (prest);

        formData.append ('nome', anagrafica.nome);
        formData.append ('cognome', anagrafica.cognome);
        formData.append ('Sesso', cf.gender);
        formData.append ('codice-fiscale', anagrafica.cf);
        formData.append ('data-nascita', cf.birthday);
        formData.append ('stato-nascita', 'Italia');
        formData.append ('comune-nascita', cf.birthplace);
        formData.append ('cellulare', anagrafica.cellulare);
        formData.append ('email', anagrafica.email);
        formData.append ('conferma-email', anagrafica.email);
        formData.append ('indirizzo-residenza', anagrafica.resIndirizzo);
        formData.append ('cap', anagrafica.resCap);
        formData.append ('comune-residenza', anagrafica.resComune);
        formData.append ('stato-residenza', anagrafica.resStato);
        formData.append ('data-impegnativa', dataImp);
        formData.append ('codice-impegnativa-S', impS);
        formData.append ('codice-impegnativa-Y', impY);
        formData.append ('numero-ricetta-elettronica', impRe);
        formData.append ('prestazione-richiesta', prest.get ('name'));
        formData.append ('note', note);
        formData.append (
          'privacy',
          anagrafica.consentGdpr === 'Y' ? 'Acconsento' : 'NON Acconsento'
        );
        formData.append (
          'trattamento-dati-personali',
          anagrafica.consentDati === 'Y' ? 'Acconsento' : 'NON Acconsento'
        );
        formData.append (
          'ricezione-comunicazioni-email',
          anagrafica.consentNews1 === 'Y' ? 'Acconsento' : 'NON Acconsento'
        );
        formData.append (
          'ricezione-comunicazioni-sms',
          anagrafica.consentNews2 === 'Y' ? 'Acconsento' : 'NON Acconsento'
        );

        const formId = (function () {
          const _popVal = prest.get ('popup');
          if (popupValueAsBoolean (_popVal) === true) {
            console.log ('***form->nuclear');
            return NUCLEAR_FORM_ID;
          }

          console.log ('***form->common');
          return prest.get ('struttura') === 'Policlinico Gemelli'
            ? GEMELLI_FORM_ID
            : COLUMBUS_FORM_ID;
        }) ();

        if (anagrafica.email.includes ('__TEST__')) {
          return false;
        }

        return await fetch (
          `/wp-json/contact-form-7/v1/contact-forms/${formId}/feedback`,
          {
            method: 'POST',
            mode: 'no-cors',
            body: formData,
          }
        )
          .then (response => response.json ())
          .then (response =>
            console.log ('Success:', JSON.stringify (response))
          )
          .catch (error => console.error ('Error:', error))
          .finally (() => {
            Store.isSent = true;
            Store._isSending = false;
            if (window.KF_PRENOTA_CALLBACK) {
              window.KF_PRENOTA_CALLBACK ();
            }
          });
      },
      {concurrency: 1}
    );

    return true;
  },
});

(function () {
  if (window.KF_WATER) {
    Store.setPrestazioneFromWater (window.KF_WATER);
  }
}) ();

export default Store;
